import React, { FC } from 'react';

import { NumericFont } from 'Shared/components';

import { PaymentPlanProps } from './types';
import styles from './styles.module.css';
import useFooterConfig from '../../hooks/useFooterConfig';

export const PaymentPlan: FC<PaymentPlanProps> = (props: PaymentPlanProps) => {
  const {
    plan,
    state,
    showPaymentPlanDetails,
    isFullPlanOnly = false,
    isMonthlyPlanOnly = false,
    'data-testid': dataTestId,
  } = props;

  const { title, subtitle } = useFooterConfig(
    state,
    plan,
    plan === 'monthly'
      ? {
          totalPayments: props.monthlyPlan.totalPayments.toString(),
          installmentAmount: props.monthlyPlan.installmentAmount,
          totalPremiumAmount: props.monthlyPlan.totalPremiumAmount,
        }
      : {
          detailsAmount: props.inFullPlan.detailsAmount,
          discountPercentage: props.inFullPlan.discountPercentage,
        },
    isFullPlanOnly,
    isMonthlyPlanOnly
  );

  const renderPaymentPlanAmount = () => {
    const value =
      plan === 'monthly'
        ? isMonthlyPlanOnly
          ? props.monthlyPlan.totalAmount
          : props.monthlyPlan.downPaymentAmount
        : props.inFullPlan.totalAmount;

    return <NumericFont className={styles.premiumAmount} value={value} />;
  };

  const renderPaymentPlanDetails = () => {
    return <div className={styles.premiumLight}>{subtitle}</div>;
  };

  return (
    <div className={styles.paymentPlan} data-testid={dataTestId}>
      <div className={styles.premiumHeavy}>
        {title}
        {renderPaymentPlanAmount()}
      </div>
      {showPaymentPlanDetails && renderPaymentPlanDetails()}
    </div>
  );
};
